import React from 'react'
import PropTypes from 'prop-types'

import InfoModalButton from 'shared/components/InfoModalButton'

import './style.scss'

// Only show uc20XX years where the record actually has non-null data.
// Hides empty future columns (e.g. uc2025+ added to the schema ahead of
// NYC publishing the data) so the table doesn't render rows with "—".
// 0 is valid data; null/undefined is not. Used for both the table rows
// and the "Stabilized Units (YYYY)" label so they always agree.
const populatedYears = record => {
  if (!record) return []
  return Object.keys(record)
    .filter(k => /^uc20\d\d$/.test(k) && record[k] != null)
    .map(k => parseInt(k.slice(2)))
    .sort((a, b) => a - b)
}

const RentStabilizationSection = props => {
  const record = props.profile.rentstabilizationrecord
  const years = populatedYears(record)
  const latestDataYear = years.length ? years[years.length - 1] : null

  return record ? (
    <div className="rentstabilization-section property-section property-summary-body">
      <div className="rentstabilization-section__top-section">
        <div className="lookup-profile-summary__group">
          <span className="profile-summary-body__label">
            Stabilized Units{latestDataYear ? ` (${latestDataYear})` : ''}:{' '}
          </span>
          <span className="profile-summary-body__value">{props.profile.unitsrentstabilized || 0}</span>
        </div>
        <div className="lookup-profile-summary__group">
          <span className="profile-summary-body__label">Change since 2007</span>
          <span className="profile-summary-body__value">
            {props.profile.rsunits_percent_lost > 0 ? '+' : ''}
            {(props.profile.rsunits_percent_lost * 100).toFixed(1) || 0}%
          </span>
        </div>
      </div>
      <div>
        <div className="renstabilization-section__table-header">
          <h6 className="profile-summary-body__label">
            # Stabilized Units{' '}
            <InfoModalButton className="lookup-profile-summary__info" modalConstant="LOOKUP_STABILIZATION" />
          </h6>
        </div>
        <table className="renstabilization-section__table">
          <tbody>
            {years.map(year => (
              <tr className="renstabilization-section__table--row" key={`rstable-year-${year}`}>
                <th>{year}</th>
                <td>{record[`uc${year}`]}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  ) : (
    <div className="rentstabilization-section property-section property-summary-body">
      <div>No Rent Stabilization History</div>
    </div>
  )
}

RentStabilizationSection.propTypes = {
  profile: PropTypes.object,
  dispatch: PropTypes.func,
  request: PropTypes.object,
}

export default RentStabilizationSection
